import React from 'react';
import {connect} from 'react-redux'
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import MenuIcon from '@mui/icons-material/Menu';
import AddIcon from '@mui/icons-material/Add';
import InputIcon from '@mui/icons-material/Input';
import InfoIcon from '@mui/icons-material/Info';
import { SearchInput } from '../../../../components/';
import { asPercent } from '../../../../helpers';
import { Paper } from '@mui/material';
import useClasses from '../../../../helpers/useClasses';

import {
  AppBar,
  Toolbar,
  Fab,
  Hidden,
  IconButton,
  Card,
  CardActions,
  Divider,
  CardHeader,
  Typography,
  CardContent,
  GridLegacy as Grid,
  Switch,
  Checkbox,
  TextField,
  Tooltip,
  ClickAwayListener
} from '@mui/material';

const styles = theme => ({
  root: {
    boxShadow: 'none',
    backgroundColor: '#fff'
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1),
    color: theme.palette.black
  },
  searchInput: {
    marginRight: '50px'
  },
  fab: {
    marginRight: '30px'
  },
  sidebarToggle: {
    color: theme.palette.black
  },
  contribution_container: {
    display: 'flex'
  },
  contribution_caution: {
    color: '#fb8c00',
    fontWeight: 'bold',
    textAlign: 'right'
  },
  contribution_ok: {
    color: '#43a047',
    fontWeight: 'bold',
    textAlign: 'right'
  },
  contribution_low: {
    color: '#C22121',
    fontWeight: 'bold',
    textAlign: 'right'
  },
  warning_bar: {
    backgroundColor: '#fb8c00',
    '& p,h3': {
      color: '#fff'
    }
  },
  proBadge: {
    color: '#fff',
      marginLeft: '15px',
    fontSize: '20px',
    backgroundColor: '#17507f',
    padding: '5px',
    borderRadius: '5px'
  }
});

const Topbar = props => {
  const { className, onSidebarOpen, onMerchantSearchClick, onLogoutClick, user, ...rest } = props;

  const classes = useClasses(styles);

  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const ContributionPercentage = (props) => {
    const { val } = props;
    let percent = 0;
    let cssName = classes.contribution_caution;
    
    if (val > 0){
      percent = asPercent(val);
    
      if (percent > 1)
        cssName = classes.contribution_ok;
      if (percent < 0.5)
        cssName = classes.contribution_low;
    } else {
      cssName = classes.contribution_low;
    }
    return (
      <div className={cssName}>
        { percent }% 
      </div>
    );
  }

  const ContributionPercentageIndicator = (props) => {
    const { val, hide } = props;
    
    if (!hide) {
      return (
        <div>
          <Grid
            container
            justifyContent="space-between"
          >
            <Grid item>
              <Typography
                className={classes.title}
                color="textSecondary"
                variant="body2"
              >
                90 DAY CONTRIBUTION
                <ClickAwayListener onClickAway={handleTooltipClose}>
                  <Tooltip
                    PopperProps={{
                      disablePortal: true,
                    }}
                    onClose={handleTooltipClose}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title="Minimum upload percentage to search is 0.5%"
                  >
                    <IconButton aria-label="info" className={classes.margin} size="small" onClick={handleTooltipOpen}>
                      <InfoIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </ClickAwayListener>
              </Typography>
              <Typography variant="h4"><ContributionPercentage val={Math.min(val, 1)} /></Typography>
            </Grid>
          </Grid>
        </div>
      );
    }
    else {
      return null;
    }
  }

  return (
    <AppBar
      // className={clsx(classes.root, className)}
      sx={{
        boxShadow: 'none',
        backgroundColor: '#fff'
      }}
    >
      <Toolbar>
        <RouterLink to="/">
          <img
            alt="Logo"
            src="/images/logos/logo.png"
            height="40px"
          />
        </RouterLink>
        { user.plan_level === 'PRO' ? 
        <Typography
          variant="h5"
          className={classes.proBadge}
          sx={{
            color: '#fff',
            marginLeft: '15px',
            fontSize: '20px',
            backgroundColor: 'palette.blue',
            padding: '5px',
            borderRadius: '5px'
          }}
        >
          PRO
        </Typography>
        : null }
        <div className={classes.flexGrow} />
        <ContributionPercentageIndicator val={user.account_total_ninety_days_contribution_percentage} hide={false} /*user.account_contribution_override} */ />
        <Paper sx={{ display: { xs: "none" } }}>
          <SearchInput
            className={classes.searchInput}
            onSearchClick={onMerchantSearchClick}
          />
          <RouterLink to="/merchants/new">
            <Fab color="primary" className={classes.fab}>
              <AddIcon />
            </Fab>
          </RouterLink>
          <IconButton
            className={classes.signOutButton}
            onClick={onLogoutClick}
          >
            <InputIcon />
          </IconButton>
        </Paper>
        <Paper sx={{ display: { sm: "block", md: "none" } }}>
          <IconButton
            onClick={onSidebarOpen}
            className={classes.sidebarToggle}
          >
            <MenuIcon />
          </IconButton>
        </Paper>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps, null)(Topbar)